import { AuditClient } from './AuditClient';
import HttpClient from '../../gateway/HttpClient';
import { notUndefined } from '../../util/Assert';
import { AuditLog } from '../../domain/rbac/RbacDomains';
import HttpMethod from '../../constant/HttpMethod';
import { AuditLogMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import Query = query.Query;
import Filter = query.Filter;
import Order = query.Order;

class NestAuditClient implements AuditClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public getCount(query: Query): Promise<any> {
    return this.httpClient.execute(HttpMethod.GET, `${AuditLogMethods.COUNT}`, {}, { query });
  }

  public async getKeycloakLoginEvents(first: number, max: number, filter: Filter, sorts: Order[]): Promise<any> {
    const dto = { first: first, max: max, filter: filter, sorts: sorts };
    return await this.httpClient.execute(HttpMethod.POST, `${AuditLogMethods.KEYCLOAK_LOGIN_AUDITS}`, dto);
  }

  public async getKeycloakAdminEvents(first: number, max: number, filter: Filter, sorts: Order[]): Promise<any> {
    const dto = { first: first, max: max, filter: filter, sorts: sorts };
    return await this.httpClient.execute(HttpMethod.POST, `${AuditLogMethods.KEYCLOAK_ADMIN_AUDITS}`, dto);
  }

  public async getComponentAudits(skip: number, limit: number, index: string, filter: Filter, sorts: Order[]): Promise<AuditLog[]> {
    const dto = { skip, limit, index, filter, sorts };
    return await this.httpClient.execute(HttpMethod.POST, `${AuditLogMethods.GET_COMPONENT_LOGS}`, dto);
  }

  public async countKeycloakLoginEvents(filter: Filter): Promise<number> {
    return await this.httpClient.execute(HttpMethod.POST, `${AuditLogMethods.KEYCLOAK_LOGIN_AUDITS_COUNT}`, { filter });
  }

  public async countKeycloakAdminEvents(filter: Filter): Promise<number> {
    return await this.httpClient.execute(HttpMethod.POST, `${AuditLogMethods.KEYCLOAK_ADMIN_AUDITS_COUNT}`, { filter });
  }

  public async getAuditLog(query: Query): Promise<AuditLog[]> {
    return await this.httpClient.execute(HttpMethod.GET, `${AuditLogMethods.GET}`, {}, { query });
  }

  public async save(log: AuditLog): Promise<void> {
    await this.httpClient.execute(HttpMethod.POST, `${AuditLogMethods.SAVE}`, log);
  }
}

export default NestAuditClient;
